export default [
  {
    value: "https://cdn.laddition.com/13/1605537654873-yk0b89khknnz2x.png",
    name: "tr-image4-name",
  },
  {
    value: "https://cdn.laddition.com/13/1605537515396-yk0b89khknkzgk.png",
    name: "tr-image5-name",
  },
  {
    value: "https://cdn.laddition.com/13/plateau-1.jpg",
    name: "tr-image9-name",
  },
  {
    value: "https://cdn.laddition.com/13/1605537396221-yk0b89khknifi5.png",
    name: "tr-image1-name",
  },
  {
    value: "https://cdn.laddition.com/13/pizza-1.jpg",
    name: "tr-image6-name",
  },
  {
    value: "https://cdn.laddition.com/13/pizza-2.jpg",
    name: "tr-image7-name",
  },
  {
    value: "https://cdn.laddition.com/13/1605537460190-yk0b89khknjsv2.png",
    name: "tr-image8-name",
  },
  {
    value: "https://cdn.laddition.com/13/1605537431638-yk0b89khknj6ty.png",
    name: "tr-image2-name",
  },
  {
    value: "https://cdn.laddition.com/13/1605537548411-yk0b89khknloxn.png",
    name: "tr-image3-name",
  },
  {
    value: "https://cdn.laddition.com/13/grillades-1.jpg",
    name: "tr-image27-name",
  },
  {
    value: "https://cdn.laddition.com/13/thai-1.jpg",
    name: "tr-image28-name",
  },
  {
    value: "https://cdn.laddition.com/13/firefly-gastronomie-chinoise-20930.jpg",
    name: "tr-image10-name",
  },
  {
    value: "https://cdn.laddition.com/13/firefly-gastronomie-chinoise-77049.jpg",
    name: "tr-image11-name",
  },
  {
    value: "https://cdn.laddition.com/13/firefly-nourriture-chinoise-20930.jpg",
    name: "tr-image12-name",
  },
  {
    value: "https://cdn.laddition.com/13/gastrojap1.jpg",
    name: "tr-image13-name",
  },
  {
    value: "https://cdn.laddition.com/13/gastrojap2.jpg",
    name: "tr-image14-name",
  },
  {
    value: "https://cdn.laddition.com/13/gastrojap3.jpg",
    name: "tr-image15-name",
  },
  {
    value: "https://cdn.laddition.com/13/epicerie-1.jpg",
    name: "tr-image16-name",
  },
  {
    value: "https://cdn.laddition.com/13/epicerie-2.jpg",
    name: "tr-image17-name",
  },
  {
    value: "https://cdn.laddition.com/13/brasserie-1.jpg",
    name: "tr-image18-name",
  },
  {
    value: "https://cdn.laddition.com/13/brasserie-2.jpg",
    name: "tr-image19-name",
  },
  {
    value: "https://cdn.laddition.com/13/caviste-1.jpg",
    name: "tr-image20-name",
  },
  {
    value: "https://cdn.laddition.com/13/caviste-2.jpg",
    name: "tr-image21-name",
  },
  {
    value: "https://cdn.laddition.com/13/caviste-3.jpg",
    name: "tr-image22-name",
  },
  {
    value: "https://cdn.laddition.com/13/dessert-1.jpg",
    name: "tr-image24-name",
  },
];